export const PrivacyData = [
  {
    listName: "Information Collection",
    list: [
      {
        item: "If you use the Platform as a Buyer, we may access and collect:",
      },
      {
        item: "Personal Information, including but not limited to your name, phone number, email address, and identification card details",
      },
      {
        item: "Your contact lists. Buyers can create a Wishlist which can be seen by contacts who have also signed up to Pamo and have enabled Pamo to access their contact list.  This feature is only available if you allow the app to access your contact list.",
      },
      {
        item: "Images from your camera or gallery to perform any of the following: creating your profile so users can see your profile picture in your posts, make a post so your post is more descriptive, attach an image when chatting with another user, make an offer so users can see images of the item you are offering, upload an image so users can see items in your Store.",
      },
      {
        item: "Pamo shall only access images from your camera or gallery after you grant Pamo access.",
      },
      {
        item: "We may also collect your location for Pamo to perform pickup and delivery of items for deals closed on the Pamo App.",
      },
      {
        item: "We may also collect the following information in addition to the Personal Information I collected from a Merchant:",
      },
      {
        item: "If you are a Verified Merchant, we will collect information about your brand, reputation, website address, and business including but not limited to registration documents, licenses, and the products you intend to offer to sell on the Platform and any other necessary information needed for verification; Verified Merchants are merchants who have earned a Pamo verification badge upon the submission of relevant registration documents.",
      },
      {
        item: "If you are a Merchant, we will collect information about your business including but not limited to registration documents, licenses, and the products you intend to offer to sell on the Platform; Merchants are individuals and businesses who sell on the Pamo App and have not been verified by Pamo,",
      },
      {
        item: "if you are a Trained Agent, we will collect information about your educational background and professional experience. Trained agents are independent contractors contracted by Pamo for activations and sales.",
      },
      {
        item: "We may also collect additional information that you voluntarily provide in response to our questionnaires including but not limited to nationality, sex, monthly spending, and user preferences.",
      },
    ],
  },
  {
    listName: "Use of Information",
    list: [
      {
        item: "We use the information we collect from you for the following purposes:",
      },
      {
        item: "provide our services;",
      },
      {
        item: "maintain & improve our services;",
      },
      {
        item: "develop new services;",
      },
      {
        item: "measure performance;",
      },
      {
        item: "communicate with you;",
      },
      {
        item: "facilitate your communication with other Users of the Platform;",
      },
      {
        item: "verify your identity and the Users' identities on the Platform;",
      },
      {
        item: "set up User accounts;",
      },
      {
        item: "provide customer service support;",
      },
      {
        item: "process transactions and payments;",
      },
      {
        item: "provide delivery services;",
      },
      {
        item: "provide user benefits;",
      },
      {
        item: "verify transactions;",
      },
      {
        item: "prevent fraud, money laundering, cyber-attacks, and other security incidents;",
      },
      {
        item: "conduct market survey;",
      },
      {
        item: "and any other purposes which are not inconsistent with this Policy and applicable law.",
      },
    ],
  },
  {
    listName: "Rights to Access and Manage Information We Collect",
    list: [
      {
        item: "Users have the right to access and manage the information they provide to Pamo. Users may request to review, correct, or delete any information that has been provided by the user. ",
      },
      {
        item: "Users can export/download a copy of their information by utilizing the feature on the App. ",
      },
    ],
  },
  {
    listName: "Non-disclosure",
    list: [
      {
        item: "We do not share your Personal Information with companies, organizations, or individuals except in the following cases:",
      },
      {
        item: "We may disclose your Personal Information to only persons you have consented to. This includes but is not limited to third parties offering participation in co-branded promotions or special offers",
      },
      {
        item: "We may disclose your Personal Information to other users of the Platform where necessary to support transactions and communications made between you and other users.",
      },
      {
        item: "We may provide your Personal Information to our affiliates and other trusted businesses or persons including but not limited to our payment service providers and our cloud computing service providers to process your Personal Information for us, based on our instructions and in compliance with our Privacy Policy and any other appropriate confidentiality and security measures",
      },
      {
        item: "We will share your Personal Information if we have a good-faith belief that access, use, preservation, or disclosure of the information is reasonably necessary to meet any applicable law, regulation, legal process, or enforceable governmental request.",
      },
      {
        item: "We may share your personal information with the relevant parties involved in the event of a merger, acquisition, reorganization, or sale of all or a portion of Pamo's business assets. This may include potential buyers, investors, legal and financial advisors, or other entities participating in the transaction, subject to appropriate confidentiality obligations.",
      },
    ],
  },
  {
    listName: "Information Disclosure",
    list: [
      {
        item: "While we use the information, you provide to provide the Services, there are circumstances where we may need to disclose your information to third parties, and this section outlines how and when such disclosures may occur:",
      },
    ],
  },
  {
    listName: "Disclosure to Third-Party Service Providers",
    list: [
      {
        item: "We may share your Personal Information and usage data with third-party service providers who assist us in operating the Pamo app and delivering our services. These service providers include, but are not limited to:",
      },
      {
        item: "Payment processing companies",
      },
      {
        item: "Data analytics service providers",
      },
      {
        item: "Customer support personnel (as may be required) to provide timely assistance.",
      },
      {
        item: "These third parties are mandated to maintain the confidentiality of your information and are prohibited from using it for any purpose other than to perform their contractual obligations to Pamo.",
      },
    ],
  },

  {
    listName: "Legal Obligations and Compliance",
    list: [
      {
        item: "We may disclose your information to law enforcement agencies, regulatory bodies, or other governmental entities if required to do so by law, or if we believe such disclosure is necessary to:",
      },
      {
        item: "Comply with a legal obligation, such as a subpoena, court order, or legal process.",
      },
      {
        item: "Protect the rights, property, or safety of Pamo, our users, or the public.",
      },
      {
        item: "Investigate potential violations of our Terms and Conditions or other agreements.",
      },
    ],
  },
  {
    listName: "With Your Consent",
    list: [],
  },
  {
    listName: "Aggregated and Anonymized Information",
    list: [
      {
        item: "We may also disclose information that has been aggregated or anonymized in a way that does not directly identify you. This information may be used for:",
      },
      {
        item: "Marketing and advertising purposes.",
      },
      {
        item: "Conducting research and analysis.",
      },
      {
        item: "Improving our services and developing new features.",
      },
    ],
  },
  {
    listName: "Cookies",
    list: [
      {
        item: "A cookie is a small piece of data sent from a website and stored on your phone which allows websites to record your browsing activity and remember information.We use cookies: to provide you with personalized content; make relevant advertisements to you; maintain your preferences; enhance your experience on the platform; track and prevent fraud, spam, and abuse; and understand how you engage with our platform.",
      },
    ],
  },
  {
    listName: "Data Transfers",
    list: [
      {
        item: "Your information may be stored and/or processed on servers located outside of the country where you live. Notwithstanding where your information is stored or processed, we apply the same protections described in this policy.",
      },
    ],
  },
  {
    listName: "Data Security",
    list: [
      {
        item: `We will implement appropriate measures to prevent unauthorized access to your Personal Information and to maintain data integrity. We will notify you if we become aware of any unauthorized access to your Personal Information.
Transmission of information over the internet cannot be perfectly secured. We will use our best endeavors to secure your Personal Information transmitted over the internet. However, we do not guarantee the unreserved security of your Personal Information.`,
      },
    ],
  },
  {
    listName: "Information/Data Storage",
    list: [
      {
        item: "We store your information securely using appropriate technical and organizational measures to protect it from unauthorized access, loss, or misuse. Your data is retained only as long as necessary to fulfill the purposes for which it was collected or as required by applicable laws and regulations.",
      },
    ],
  },
  {
    listName: "Legal Basis for Data Processing",
    list: [
      {
        item: "We process Personal Information for the purposes set out in this Privacy Policy. Our legal basis for processing your personal information includes instances where it is necessary for the performance of the contract between you and us, to comply with legal requirements, or to serve our legitimate interests.",
      },
    ],
  },
  {
    listName: "Amendment",
    list: [
      {
        item: `This Policy is effective as of the date and time it is posted on this page. This Policy shall remain in effect except for any changes in its provisions in the future, which shall be effective immediately after being posted on this page. We reserve the right to update or change our Privacy Policy at any time; you are required to check this Policy periodically. Your continued use of the Service after we post any modifications to this Policy on this page will constitute your acknowledgment of the modifications and your consent to abide by and be bound by the modified Privacy Policy. `,
      },
    ],
  },
];
